import { render, staticRenderFns } from "./labelWidth-editor.vue?vue&type=template&id=25760c4a&scoped=true"
import script from "./labelWidth-editor.vue?vue&type=script&lang=js"
export * from "./labelWidth-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25760c4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25760c4a')) {
      api.createRecord('25760c4a', component.options)
    } else {
      api.reload('25760c4a', component.options)
    }
    module.hot.accept("./labelWidth-editor.vue?vue&type=template&id=25760c4a&scoped=true", function () {
      api.rerender('25760c4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/labelWidth-editor.vue"
export default component.exports